import { render, staticRenderFns } from "./EDrawerVisualizarAtendimento.vue?vue&type=template&id=0b913b60&scoped=true"
import script from "./EDrawerVisualizarAtendimento.vue?vue&type=script&lang=js"
export * from "./EDrawerVisualizarAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b913b60",
  null
  
)

export default component.exports